<template>
  <div class="order">
    <div class="custom-container">
      <div class="wrap">
        <v-stepper class="form-stepper" v-model="step" vertical>
          <v-stepper-step :complete="step > 1" step="1"
            >Din strømmåler</v-stepper-step
          >
          <v-stepper-content step="2">
            <v-card class="step-2">
              <div class="label">Målepunkt hvor strømmen skal leveres</div>

              <div class="accounting-poins">
                <div
                  v-for="(item, key) in contracts"
                  class="point list-point"
                  :key="key"
                >
                  <v-checkbox
                    v-model="checkboxes"
                    :value="item.AccountingPointIdentification"
                  ></v-checkbox>
                  <div class="point-info">
                    <div class="name">
                      {{ item.Address.StreetName }}
                      {{ item.Address.BuildingNumber }},
                      {{ item.Address.PostCode }} {{ item.Address.CityName }}
                    </div>
                    <div class="id">
                      {{ maskAPid(item.AccountingPointIdentification) }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="accounting-poins custom-points"
                v-if="customContracts.length"
              >
                <div v-for="(item, key) in customAP" class="point" :key="key">
                  <div class="list-point">
                    <v-checkbox v-model="item.customAPcheck"></v-checkbox>
                    <div class="point-info">
                      <div class="name">
                        {{ item.AccountingPoint.Address.StreetName }}
                        {{ item.AccountingPoint.Address.BuildingNumber }},
                        {{ item.AccountingPoint.Address.PostCode }}
                        {{ item.AccountingPoint.Address.CityName }}
                      </div>
                    </div>
                  </div>

                  <div class="label">Din strømmåler</div>
                  <div class="sublabel">
                    MålepunktID kan du finne på din strømfaktura. Har du ikke en
                    faktura å se på kan du søke med målernummer, som du finner
                    fysisk på din strømmåler. Har du ingen av delene kan du la
                    dem stå tomme og så kontakter vi deg i etterkant. Eller du
                    kan ringe kundeservice for å få hjelp.
                  </div>

                  <div class="input-row">
                    <v-text-field
                      v-model="item.apId"
                      hide-details
                      placeholder="MålepunktID (18 siffer)"
                    ></v-text-field>
                    <p v-if="item.error" class="custom-error">
                      Vi klarte ikke å finne målepunktet. Sjekk om tallene er
                      riktig og prøv igjen.
                    </p>
                  </div>

                  <p>eller</p>

                  <div class="input-row id-post-input">
                    <v-text-field
                      class="id-input"
                      v-model="item.apNumber"
                      hide-details
                      placeholder="Målernummer (16 siffer)"
                    ></v-text-field>
                    <v-text-field
                      class="post-code-input"
                      v-model="item.AccountingPoint.Address.PostCode"
                      hide-details
                      placeholder="Postnummer"
                      label="Postnummer"
                    ></v-text-field>
                  </div>

                  <div class="submit-wrap">
                    <v-btn
                      class="submit-btn long-submit-btn"
                      @click="findAlternatives(key)"
                    >
                      <span v-if="!item.loading">Finn strømmåler</span>
                      <v-progress-circular
                        v-if="item.loading"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-btn>
                  </div>
                </div>
              </div>

              <div v-if="editionalAddress" class="address-form">
                <div class="address-check">
                  <v-checkbox v-model="addressCheck"></v-checkbox>
                  <p>Adresse til strømmåleren din</p>
                </div>

                <div class="input-row">
                  <v-text-field
                    v-model="address.street"
                    placeholder="Gate"
                  ></v-text-field>
                  <v-text-field
                    v-model="address.house"
                    placeholder="Nummer"
                  ></v-text-field>
                </div>

                <div class="input-row">
                  <v-text-field
                    v-model="address.zip"
                    placeholder="Postnummer"
                    label="Postnummer"
                  ></v-text-field>
                </div>

                <div class="submit-wrap">
                  <v-btn
                    class="submit-btn medium-submit-btn"
                    @click="addAddress()"
                  >
                    <span v-if="!findAddressLoading">Finn måler</span>
                    <v-progress-circular
                      v-if="findAddressLoading"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-btn>
                  <v-btn
                    v-if="customContracts || contracts.length"
                    class="submit-btn clear-bold-btn"
                    @click="editionalAddress = false"
                    text
                    >Avbryt</v-btn
                  >
                </div>
              </div>

              <div
                class="submit-wrap"
                v-if="
                  (customContracts && !editionalAddress) ||
                  (contracts.length && !editionalAddress)
                "
              >
                <v-btn class="submit-btn" @click="editionalAddress = true"
                  >Legg til bolig</v-btn
                >
              </div>

              <div class="date-wrap">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="200px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formatedDate"
                      prepend-icon="mdi-calendar"
                      placeholder="Ønsket oppstartsdato"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="date"
                    @change="save"
                    :min="minDate"
                  ></v-date-picker>
                </v-menu>
              </div>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="step > 1" step="2"
            >Bekreft din bestilling</v-stepper-step
          >
          <v-stepper-content step="3">
            <v-card class="step-3">
              <div class="label">Hvor skal vi sende bekreftelsen</div>
              <v-text-field
                v-model="submitEmail"
                hide-details
                placeholder="Din e-postadresse"
                outlined
                :rules="[rules.required, rules.email]"
              ></v-text-field>

              <div class="privacy">
                <v-checkbox hide-details v-model="pravicy"></v-checkbox>
                <span
                  >Jeg godtar
                  <a :href="privacyLink" target="blank"
                    >avtalevilkårene</a
                  ></span
                >
              </div>

              <div class="submit-wrap" @click="submitOrder()">
                <v-btn class="submit-btn primary">Bekreft din bestilling</v-btn>
              </div>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </div>
    </div>
  </div>
</template>

<script>
import { account } from "../../api/common";

import "./Order.scss";

export default {
  name: "Order",

  components: {},

  data() {
    return {
      step: 2,
      checkboxes: [],
      customContracts: [],
      editionalAddress: false,
      addressCheck: true,
      menu: false,
      date: "",
      minDate: "",
      formatedDate: "",
      submitEmail: "",
      privacyLink: "",
      findAddressLoading: false,
      address: "",
      pravicy: false,
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },

  mounted() {
    if (localStorage.tenant === "9876543210517") {
      this.menuClass = "sokrates";
      this.privacyLink = "";
    } else if (localStorage.tenant === "7080010002488") {
      this.menuClass = "klark";
      this.privacyLink = "http://www.klarkraft.no/avtalevilkår";
    } else {
      this.menuClass = "hks";
      this.privacyLink = "https://www.helgelandkraft.no/strom/privat/vilkar/";
    }

    this.minDate = this.$moment(new Date()).subtract(40, "d").toISOString();
    this.getAccount();
  },

  computed: {
    contracts() {
      return this.$store.getters["getContracts"];
    },
  },

  watch: {
    date(val) {
      if (val) {
        this.formatedDate = this.$moment(val).format("DD-MM-YYYY");
      }
    },
  },

  methods: {
    save(date) {
      this.$refs.menu.save(date);
    },

    maskAPid(id) {
      return id.replace(id.substring(10, 14), "****");
    },

    getAccount() {
      return new Promise((resolve, reject) => {
        account()
          .then((res) => {
            if (res.data) {
              let account = res.data.Accounts[0];

              this.address = {
                street: account.Addresses[0].StreetName,
                house: account.Addresses[0].BuildingNumber,
                zip: account.Addresses[0].PostCode,
              };
            }
          })
          .catch((error) => {
            console.log(error);

            reject(error);
          });
      });
    },

    addAddress() {},
  },
};
</script>

